export default __webpack_public_path__ + "static/media/logo-with-tagline.af09a8d0.png";